module.exports = __webpack_public_path__ + "static/media/TL.fb83d42d.png";